<template>
  <div>
    <a-button size="small" type="link" @click="handleShowModal">Replicar</a-button>

    <a-modal
      v-model:visible="visible"
      title="Replicar plantilla desde"
      :body-style="{ padding: '12px 24px' }"
      width="400px"
      centered
      :keyboard="false"
      :mask-closable="false"
    >
      <p>
        Selecciona la empresa y campaña de la cuál quieres replicar su plantilla de
        {{ type === "contacts" ? "clientes" : "productos" }}.
      </p>
      <a-form class="form" layout="vertical">
        <!-- <a-form-item label="Empresa"> -->
        <!--   <a-select :getPopupContainer="triggerNode => triggerNode.parentNode" -->
        <!--     v-model:value="selectedEntity" -->
        <!--     placeholder="Seleccione empresa" -->
        <!--     @change="handleEntityChange" -->
        <!--   > -->
        <!--     <a-select-option v-for="entity in entities" :key="entity.id"> -->
        <!--       {{ entity.name }} -->
        <!--     </a-select-option> -->
        <!--   </a-select> -->
        <!-- </a-form-item> -->
        <!---->
        <!-- <a-form-item label="Campaña"> -->
        <!--   <a-select :getPopupContainer="triggerNode => triggerNode.parentNode" v-model:value="selectedPortfolio" placeholder="Seleccione campaña"> -->
        <!--     <a-select-option v-for="portfolio in portfolios" :key="portfolio.id"> -->
        <!--       {{ portfolio.name }} -->
        <!--     </a-select-option> -->
        <!--   </a-select> -->
        <!-- </a-form-item> -->

        <EntityPicker v-model:value="selectedEntity" default-behavior :show-all="false" />

        <CampaignPicker
          v-model:value="selectedPortfolio"
          default-behavior
          :entity="selectedEntity"
          :show-all="false"
        />
      </a-form>

      <div class="info__container">
        <a-tooltip>
          <template #title>
            <span> Información </span>
          </template>
          <InfoCircleOutlined class="info__icon" />
        </a-tooltip>
        <p>
          Recuerda que si ya tienes una plantilla creada en tu campaña, esta réplica actualizará lo
          existente.
        </p>
      </div>

      <template v-slot:footer>
        <a-button @click="handleCancel"> Cancelar </a-button>
        <a-button type="primary" :loading="loading" @click="handleOk"> Replicar </a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";

import EntityPicker from "@/app/shared/components/pickers/EntityPicker.vue";
import CampaignPicker from "@/app/shared/components/pickers/CampaignPicker.vue";

export default defineComponent({
  components: {
    InfoCircleOutlined,
    EntityPicker,
    CampaignPicker,
  },
  props: {
    type: {
      required: true,
      type: String,
      validator: (value) => ["client", "product"].includes(value),
    },
  },
  data() {
    return {
      selectedEntity: undefined,
      selectedPortfolio: undefined,
      visible: false,
      loading: false,
    };
  },
  computed: {
    entities() {
      return this.$store.getters["getEntityList"];
    },
    portfolios() {
      return this.$store.getters["getFilteredPortfolios"];
    },
  },
  methods: {
    handleEntityChange(entityId) {
      this.selectedPortfolio = undefined;
      this.$store.dispatch("setSelectedEntity", entityId);
      this.$store.dispatch("fetchAllPortfoliosByEntity");
    },
    async handleOk() {
      try {
        this.loading = true;
        await this.$store.dispatch("replicateTemplateFromPortfolio", {
          type: this.type,
          source: this.selectedPortfolio,
        });
        await this.$store.dispatch("fetchTemplateByPortfolio");
        this.visible = false;
      } catch {
        this.$notification.error({ message: "Algo salió mal" });
      } finally {
        this.loading = false;
      }
    },
    handleShowModal() {
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
    },
  },
});
</script>

<style lang="sass" scoped>
.form
  display: block
  margin: 0 auto
  max-width: 240px

.info
  &__container
    display: grid
    grid-template-columns: auto 1fr
    gap: 8px

  &__icon
    margin-top: 4px

.ant-form-item
  margin-bottom: 16px
</style>
